import React, { Component } from 'react';
import { Link } from 'react-router';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import {
  getProcedureTypes,
  getSurgeons,
  getHospitals,
  getTeamReps,
  getBillingFilterFieldList,
  getAltCaseTypes
} from '../utils/db';
import withCaseFilter from '../common/withCaseFilter';
import withTableName from '../common/withTableName';
import withSearchFilter from '../common/withSearchFilter';
import { sortData } from '../common/globals';
import Bugsnag from '../helpers/bugsnag';

class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectHospitals: [],
      keywordSearch: '',
      selectedStartDate: '',
      selectedEndDate: '',
      selectedRefs: [],
      selectedTypes: [],
      selectedProcedures: [],
      selectSurgeon: [],
      // selectPOIssues: [],
      PatientID: [],
      repData: [],
      // poIssues: [{ text: 'PO Issue', id: 1 }, { text: 'No PO Issue', id: 2 }],
      hospitals: [],
      surgeons: [],
      types: [],
      procedures: [],
      patients: [],
      sortOrder: 'desc',
      clearData: {},
      filterRepData: '',
      filterHospitalData: '',
      filterSurgeonData: '',
      filterTypeData: '',
      filterProcedureData: '',
      filterPatientIDData: '',
      repSearchResult: [],
      hospitalSearchResult: [],
      surgeonSearchResult: [],
      typeSearchResult: [],
      procedureSearchResult: [],
      patientSearchResult: [],
      isSearchRep: false,
      isSearchHospital: false,
      isSearchSurgeon: false,
      isSearchType: false,
      isSearchProcedure: false,
      isSearchPatientID: false,
    };
  }

  _onClearFilter = () => {
    // eslint-disable-next-line react/prop-types
    const { onClearFilter, setCaseFilter } = this.props;
    this.setState({
      selectHospitals: [],
      keywordSearch: '',
      selectedStartDate: '',
      selectedEndDate: '',
      selectedRefs: [],
      selectedTypes: [],
      selectedProcedures: [],
      selectSurgeon: [],
      sortOrder: 'desc',
      clearData: {},
      PatientID: [],
      // selectPOIssues: []
    });
    setCaseFilter({});
    onClearFilter();
  }

  _onUnSelectRef = async (id) => {
    try {
      let { selectedRefs } = this.state;
      // eslint-disable-next-line react/prop-types
      const { caseFilter, setCaseFilter } = this.props;
      if (selectedRefs.includes(id)) {
        selectedRefs = selectedRefs.filter((val) => val !== id);
        this._onFilter({ selectedRefs });
        this.setState({ selectedRefs }, () => {
          setCaseFilter({ ...caseFilter, selectedRefs: '' });
          this.setClearFilter();
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectRef = async (id) => {
    try {
      const { selectedRefs } = this.state;
      if (selectedRefs.indexOf(id) > -1) {
        selectedRefs.splice(selectedRefs.indexOf(id), 1);
      } else {
        selectedRefs.push(id);
        this._onFilter({ selectedRefs });
      }
      this.setState({ selectedRefs }, () => {
        this.setClearFilter();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onUnSelectType = async (id) => {
    try {
      let { selectedTypes } = this.state;
      // eslint-disable-next-line react/prop-types
      const { caseFilter, setCaseFilter } = this.props;
      if (selectedTypes.includes(id)) {
        selectedTypes = selectedTypes.filter((val) => val !== id);
        this._onFilter({ selectedTypes });
        this.setState({ selectedTypes }, () => {
          setCaseFilter({ ...caseFilter, selectedTypes: '' });
          this.setClearFilter();
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectType = async (id) => {
    try {
      const { selectedTypes } = this.state;
      if (selectedTypes.indexOf(id) > -1) {
        selectedTypes.splice(selectedTypes.indexOf(id), 1);
      } else {
        selectedTypes.push(id);
        this._onFilter({ selectedTypes });
      }
      this.setState({ selectedTypes }, () => {
        this.setClearFilter();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onUnSelectProcedure = async (id) => {
    try {
      let { selectedProcedures } = this.state;
      // eslint-disable-next-line react/prop-types
      const { caseFilter, setCaseFilter } = this.props;
      if (selectedProcedures.includes(id)) {
        selectedProcedures = selectedProcedures.filter((val) => val !== id);
        this._onFilter({ selectedProcedures });
        this.setState({ selectedProcedures }, () => {
          setCaseFilter({ ...caseFilter, selectedProcedures: '' });
          this.setClearFilter();
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectProcedures = async (id) => {
    try {
      const { selectedProcedures } = this.state;
      if (selectedProcedures.indexOf(id) > -1) {
        selectedProcedures.splice(selectedProcedures.indexOf(id), 1);
      } else {
        selectedProcedures.push(id);
        this._onFilter({ selectedProcedures });
      }
      this.setState({ selectedProcedures }, () => {
        this.setClearFilter();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onUnSelectHospital = async (id) => {
    try {
      let { selectHospitals } = this.state;
      // eslint-disable-next-line react/prop-types
      const { caseFilter, setCaseFilter } = this.props;
      if (selectHospitals.includes(id)) {
        selectHospitals = selectHospitals.filter((val) => val !== id);
        this._onFilter({ selectHospitals });
        this.setState({ selectHospitals }, () => {
          setCaseFilter({ ...caseFilter, selectHospitals: '' });
          this.setClearFilter();
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectHospital = async (id) => {
    /* const { selectHospitals } = this.state;
    if (!selectHospitals.includes(id)) {
      selectHospitals.push(id);
      this._onFilter({ selectHospitals });
      await this.setState({ selectHospitals }, () => {
        this.setClearFilter();
      });
    } */
    try {
      const { selectHospitals } = this.state;
      if (selectHospitals.indexOf(id) > -1) {
        selectHospitals.splice(selectHospitals.indexOf(id), 1);
      } else {
        selectHospitals.push(id);
        this._onFilter({ selectHospitals });
      }
      this.setState({ selectHospitals }, () => {
        this.setClearFilter();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onUnSelectSurgeon = async (id) => {
    try {
      let { selectSurgeon } = this.state;
      // eslint-disable-next-line react/prop-types
      const { caseFilter, setCaseFilter } = this.props;
      if (selectSurgeon.includes(id)) {
        selectSurgeon = selectSurgeon.filter((val) => val !== id);
        this.setState({ selectSurgeon }, () => {
          setCaseFilter({ ...caseFilter, selectSurgeon: '' });
          this.setClearFilter();
        });
        this._onFilter({ selectSurgeon });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectSurgeon = async (id) => {
    try {
      const { selectSurgeon } = this.state;
      if (selectSurgeon.indexOf(id) > -1) {
        selectSurgeon.splice(selectSurgeon.indexOf(id), 1);
      } else {
        selectSurgeon.push(id);
        this._onFilter({ selectSurgeon });
      }
      this.setState({ selectSurgeon }, () => {
        this.setClearFilter();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  /* _onUnSelectPOIssue = async (id) => {
    let { selectPOIssues } = this.state;
    if (selectPOIssues.includes(id)) {
      selectPOIssues = selectPOIssues.filter((val) => val !== id);
      this.setState({ selectPOIssues }, () => {
        this.setClearFilter();
      });
    }
  }; */

  /* _onSelectPOIssue = async ({ params: { data: { id } } }) => {
    const { selectPOIssues } = this.state;
    if (!selectPOIssues.includes(id)) {
      selectPOIssues.push(id);
      await this.setState({ selectPOIssues }, () => {
        this.setClearFilter();
      });
    }
  }; */

  _onUnSelectPatient = async (id) => {
    try {
      let { PatientID } = this.state;
      // eslint-disable-next-line react/prop-types
      const { caseFilter, setCaseFilter } = this.props;
      if (PatientID.includes(id)) {
        PatientID = PatientID.filter((val) => val !== id);
        this.setState({ PatientID }, () => {
          setCaseFilter({ ...caseFilter, PatientID: '' });
          this.setClearFilter();
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectPatient = async (id) => {
    /* const { PatientID } = this.state;
    if (!PatientID.includes(id)) {
      PatientID.push(id);
      await this.setState({ PatientID }, () => {
        this.setClearFilter();
      });
      this._onFilter({ PatientID });
    } */
    try {
      const { PatientID } = this.state;
      if (PatientID.indexOf(id) > -1) {
        PatientID.splice(PatientID.indexOf(id), 1);
      } else {
        PatientID.push(id);
        this._onFilter({ PatientID });
      }
      this.setState({ PatientID }, () => {
        this.setClearFilter();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _clearDateFilter = () => {
    try {
      this.setState({
        selectedStartDate: new Date(),
        selectedEndDate: new Date(),
      }, () => {
        this.setClearFilter();
      });
      this._onFilter({
        selectedStartDate: new Date(),
        selectedEndDate: new Date()
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFilter = (data) => {
    try {
      const { onFilter, previousData } = this.props;
      onFilter(Object.assign(previousData, data));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFutureData = () => {
    try {
      const todayDate = new Date();
      const futureDate = new Date();
      futureDate.setDate(todayDate.getDate() + 365);
      this.setState({
        selectedStartDate: new Date(todayDate),
        selectedEndDate: new Date(futureDate)
      }, () => {
        this.setClearFilter();
      });
      this._onFilter({
        selectedStartDate: new Date(todayDate),
        selectedEndDate: new Date(futureDate)
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onKeyword = (event) => {
    try {
      let keywordData = [];
      this.setState({ keywordSearch: event.target.value }, () => {
        keywordData = this.state.keywordSearch.split(',');
        this.setClearFilter();
        this._onFilter({ keywordSearch: keywordData });
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSort = ({ target: { value } }) => {
    try {
      this.setState({ sortOrder: value });
      this._onFilter({ sortOrder: value });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClear = (value) => {
    try {
      const {
        selectedRefs,
        selectHospitals,
        selectSurgeon,
        selectedTypes,
        selectedProcedures,
        keywordSearch,
        // selectPOIssues,
        PatientID
      } = this.state;
      // eslint-disable-next-line react/prop-types
      const { caseFilter, setCaseFilter } = this.props;
      this._onFilter({
        selectedRefs: value === 'selectedRefs' ? [] : selectedRefs,
        selectHospitals: value === 'selectHospitals' ? [] : selectHospitals,
        selectSurgeon: value === 'selectSurgeon' ? [] : selectSurgeon,
        selectedTypes: value === 'selectedTypes' ? [] : selectedTypes,
        selectedProcedures: value === 'selectedProcedures' ? [] : selectedProcedures,
        keywordSearch: value === 'keywordSearch' ? '' : keywordSearch,
        // selectPOIssues: value === 'selectPOIssues' ? [] : selectPOIssues,
        PatientID: value === 'PatientID' ? [] : PatientID,
      });
      setCaseFilter({
        // eslint-disable-next-line react/prop-types
        selectedRefs: value === 'selectedRefs' ? '' : caseFilter.selectedRefs !== undefined ? caseFilter.selectedRefs : '',
        // eslint-disable-next-line react/prop-types
        selectHospitals: value === 'selectHospitals' ? '' : caseFilter.selectHospitals !== undefined ? caseFilter.selectHospitals : '',
        // eslint-disable-next-line react/prop-types
        selectSurgeon: value === 'selectSurgeon' ? '' : caseFilter.selectSurgeon !== undefined ? caseFilter.selectSurgeon : '',
        // eslint-disable-next-line react/prop-types
        selectedTypes: value === 'selectedTypes' ? '' : caseFilter.selectedTypes !== undefined ? caseFilter.selectedTypes : '',
        // eslint-disable-next-line react/prop-types
        selectedProcedures: value === 'selectedProcedures' ? '' : caseFilter.selectedProcedures !== undefined ? caseFilter.selectedProcedures : '',
        // eslint-disable-next-line react/prop-types
        PatientID: value === 'PatientID' ? '' : caseFilter.PatientID !== undefined ? caseFilter.PatientID : '',
      });
      this.setState({
        selectedRefs: value === 'selectedRefs' ? [] : selectedRefs,
        selectHospitals: value === 'selectHospitals' ? [] : selectHospitals,
        selectSurgeon: value === 'selectSurgeon' ? [] : selectSurgeon,
        selectedTypes: value === 'selectedTypes' ? [] : selectedTypes,
        selectedProcedures: value === 'selectedProcedures' ? [] : selectedProcedures,
        keywordSearch: value === 'keywordSearch' ? '' : keywordSearch,
        // selectPOIssues: value === 'selectPOIssues' ? [] : selectPOIssues,
        PatientID: value === 'PatientID' ? [] : PatientID,
      }, () => {
        this.setClearFilter();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onDateClear = () => {
    try {
      this.setState({
        selectedStartDate: '',
        selectedEndDate: ''
      }, () => {
        this.setClearFilter();
      });
      this._onFilter({
        selectedStartDate: '',
        selectedEndDate: ''
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  setClearFilter = () => {
    try {
      // const { selectedFilter } = this.props;
      const {
        selectedStartDate,
        selectedEndDate,
        // selectPOIssues,
        selectedRefs,
        selectedTypes,
        selectHospitals,
        selectedProcedures,
        selectSurgeon,
        keywordSearch,
        PatientID
      } = this.state;
      let clearData = {};
      if (selectedStartDate !== null && selectedStartDate !== undefined && selectedStartDate !== '') {
        clearData = Object.assign(clearData, { selectedStartDate });
      }
      if (selectedEndDate !== null && selectedEndDate !== undefined && selectedEndDate !== '') {
        clearData = Object.assign(clearData, { selectedEndDate });
      }
      /* if (selectPOIssues.length > 0) {
        clearData = Object.assign(clearData, { selectPOIssues });
      } */
      if (selectedRefs.length > 0) {
        clearData = Object.assign(clearData, { selectedRefs });
      }
      if (selectedTypes.length > 0) {
        clearData = Object.assign(clearData, { selectedTypes });
      }
      if (selectHospitals.length > 0) {
        clearData = Object.assign(clearData, { selectHospitals });
      }
      if (selectedProcedures.length > 0) {
        clearData = Object.assign(clearData, { selectedProcedures });
      }
      if (selectSurgeon.length > 0) {
        clearData = Object.assign(clearData, { selectSurgeon });
      }
      if (PatientID.length > 0) {
        clearData = Object.assign(clearData, { PatientID });
      }
      if (keywordSearch.length > 0 || keywordSearch !== '') {
        const keywordData = this.state.keywordSearch.split(',');
        clearData = Object.assign(clearData, { keywordSearch: keywordData });
      }
      this._onFilter({
        selectedRefs: selectedRefs || [],
        PatientID: PatientID || []
      });
      this.setState({ clearData });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setHospitalData = async () => {
    try {
      const { tableName } = this.props;
      let hospitals = [];
      const hospitalData = await getBillingFilterFieldList(tableName);

      const hospitalPromiseAll = hospitalData.map(
        (data) => new Promise((resolve) => {
          if (data.CustomerName !== null) {
            hospitals.push({ CustomerName: data.CustomerName, id: data.id });
          }
          resolve(true);
        })
      );
      await Promise.all(hospitalPromiseAll);
      hospitals = [...new Map(hospitals.map((item) => [item.CustomerName, item])).values()];
      const sortHospitals = sortData(hospitals, 'CustomerName');
      this.setState({ hospitals: sortHospitals, hospitalSearchResult: sortHospitals });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setSurgeonData = async () => {
    try {
      const { tableName } = this.props;
      let surgeons = [];
      const surgeonsData = await getBillingFilterFieldList(tableName);

      const surgeonsPromiseAll = surgeonsData.map(
        (data) => new Promise((resolve) => {
          if (data.SurgeonName !== null) {
            surgeons.push({ SurgeonName: data.SurgeonName, id: data.id });
          }
          resolve(true);
        })
      );
      await Promise.all(surgeonsPromiseAll);
      surgeons = [...new Map(surgeons.map((item) => [item.SurgeonName, item])).values()];
      const sortSurgeons = sortData(surgeons, 'SurgeonName');
      this.setState({ surgeons: sortSurgeons, surgeonSearchResult: sortSurgeons });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setRepData = async () => {
    try {
      const { tableName } = this.props;
      let repData = [];
      const coverRepData = await getBillingFilterFieldList(tableName);
      const repsPromiseAll = coverRepData.map(
        (data) => new Promise((resolve) => {
          if (data.CoverRep !== null && data.CoverRep !== 'NONE') {
            repData.push({ SalesRepName: data.CoverRep, id: data.id });
          }
          resolve(true);
        })
      );
      await Promise.all(repsPromiseAll);
      repData = [...new Map(repData.map((item) => [item.SalesRepName, item])).values()];
      const sortRepData = sortData(repData, 'SalesRepName');
      this.setState({ repData: sortRepData, repSearchResult: sortRepData });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setCaseTypeData = async () => {
    try {
      const { tableName } = this.props;
      let types = [];
      const typeData = await getBillingFilterFieldList(tableName);

      const typePromiseAll = typeData.map(
        (data) => new Promise((resolve) => {
          if (data.AltCaseType !== null) {
            types.push({ AltCaseType: data.AltCaseType, id: data.id });
          }
          resolve(true);
        })
      );
      await Promise.all(typePromiseAll);
      types = [...new Map(types.map((item) => [item.AltCaseType, item])).values()];
      const sortCaseTypes = sortData(types, 'AltCaseType');
      this.setState({ types: sortCaseTypes, typeSearchResult: sortCaseTypes });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setProcedureTypeData = async () => {
    try {
      const { tableName } = this.props;
      let procedures = [];
      const procedureTypeData = await getBillingFilterFieldList(tableName);

      const procedureTypePromiseAll = procedureTypeData.map(
        (data) => new Promise((resolve) => {
          if (data.ProcedureType !== null) {
            procedures.push({ OptionName: data.ProcedureType, id: data.id });
          }
          resolve(true);
        })
      );
      await Promise.all(procedureTypePromiseAll);
      procedures = [...new Map(procedures.map((item) => [item.OptionName, item])).values()];
      const sortProcedureType = sortData(procedures, 'OptionName');
      this.setState({ procedures: sortProcedureType, procedureSearchResult: sortProcedureType });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setPatientData = async () => {
    try {
      const { tableName } = this.props;
      let patients = [];
      const patientData = await getBillingFilterFieldList(tableName);
      const patientPromiseAll = patientData.map(
        (data) => new Promise((resolve) => {
          if (data.PatientID !== null) {
            if (data.PatientID !== '') {
              patients.push({
                PatientID: data.PatientID,
                id: data.id
              });
            }
          }
          resolve(true);
        })
      );
      await Promise.all(patientPromiseAll);
      patients = [...new Map(patients.map((item) => [item.PatientID, item])).values()];
      const sortPatients = sortData(patients, 'PatientID');
      this.setState({ patients: sortPatients, patientSearchResult: sortPatients });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setBillingFilterData = async () => {
    try {
      const { selectedFilter, searchFilter } = this.props;
      await this._setHospitalData();
      await this._setSurgeonData();
      await this._setRepData();
      await this._setCaseTypeData();
      await this._setProcedureTypeData();
      await this._setPatientData();
      this.setState({
        isSearchRep: searchFilter.isSearchRep !== undefined ? searchFilter.isSearchRep : '',
        isSearchHospital: searchFilter.isSearchHospital !== undefined ? searchFilter.isSearchHospital : '',
        isSearchSurgeon: searchFilter.isSearchSurgeon !== undefined ? searchFilter.isSearchSurgeon : '',
        isSearchType: searchFilter.isSearchType !== undefined ? searchFilter.isSearchType : '',
        isSearchProcedure: searchFilter.isSearchProcedure !== undefined ? searchFilter.isSearchProcedure : '',
        isSearchPatientID: searchFilter.isSearchPatientID !== undefined ? searchFilter.isSearchPatientID : '',
        selectedStartDate: (selectedFilter.hasOwnProperty('selectedStartDate'))
          ? new Date(selectedFilter.selectedStartDate)
          : '',
        selectedEndDate: (selectedFilter.hasOwnProperty('selectedEndDate'))
          ? new Date(selectedFilter.selectedEndDate)
          : '',
        selectedTypes: (selectedFilter.hasOwnProperty('selectedTypes'))
          ? selectedFilter.selectedTypes
          : [],
        selectHospitals: (selectedFilter.hasOwnProperty('selectHospitals'))
          ? selectedFilter.selectHospitals
          : [],
        selectedRefs: (selectedFilter.hasOwnProperty('selectedRefs'))
          ? selectedFilter.selectedRefs
          : [],
        selectedProcedures: (selectedFilter.hasOwnProperty('selectedProcedures'))
          ? selectedFilter.selectedProcedures
          : [],
        selectSurgeon: (selectedFilter.hasOwnProperty('selectSurgeon'))
          ? selectedFilter.selectSurgeon
          : [],
        keywordSearch: (selectedFilter.hasOwnProperty('keywordSearch'))
          ? (selectedFilter.keywordSearch).join(',')
          : '',
        PatientID: (selectedFilter.hasOwnProperty('PatientID'))
          ? selectedFilter.PatientID
          : [],
        sortOrder: (selectedFilter.hasOwnProperty('sortOrder'))
          ? selectedFilter.sortOrder
          : 'desc'
      }, () => {
        this._onFilterData();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRepChange = (value) => {
    try {
      // eslint-disable-next-line react/prop-types
      const { setSearchFilter, searchFilter } = this.props;
      this.setState({ filterRepData: value }, () => {
        setSearchFilter({
          ...searchFilter, filterRepData: value
        });
        this._onSearchRepList();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSearchRepList = () => {
    try {
      const { filterRepData, repSearchResult } = this.state;
      const searchRes = [];
      const searchData = new RegExp(filterRepData.toUpperCase(), 'g');
      const data = repSearchResult.filter((item) => item.SalesRepName.match(searchData));
      data.map((item) => {
        searchRes.push(item);
      });
      this.setState({
        repData: filterRepData !== '' ? searchRes : repSearchResult
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onHospitalChange = (value) => {
    try {
      // eslint-disable-next-line react/prop-types
      const { setSearchFilter, searchFilter } = this.props;
      this.setState({ filterHospitalData: value }, () => {
        setSearchFilter({
          ...searchFilter, filterHospitalData: value
        });
        this._onSearchHospitalList();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSearchHospitalList = () => {
    try {
      const { filterHospitalData, hospitalSearchResult } = this.state;
      const searchRes = [];
      const searchData = new RegExp(filterHospitalData.toUpperCase(), 'g');
      const data = hospitalSearchResult.filter((item) => item.CustomerName.match(searchData));
      data.map((item) => {
        searchRes.push(item);
      });
      this.setState({
        hospitals: filterHospitalData !== '' ? searchRes : hospitalSearchResult
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSurgeonChange = (value) => {
    try {
      // eslint-disable-next-line react/prop-types
      const { setSearchFilter, searchFilter } = this.props;
      this.setState({ filterSurgeonData: value }, () => {
        setSearchFilter({
          ...searchFilter, filterSurgeonData: value
        });
        this._onSearchSurgeonList();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSearchSurgeonList = () => {
    try {
      const { filterSurgeonData, surgeonSearchResult } = this.state;
      const searchRes = [];
      const searchData = new RegExp(filterSurgeonData.toUpperCase(), 'g');
      const data = surgeonSearchResult.filter((item) => item.SurgeonName.match(searchData));
      data.map((item) => {
        searchRes.push(item);
      });
      this.setState({
        surgeons: filterSurgeonData !== '' ? searchRes : surgeonSearchResult
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onTypeChange = (value) => {
    try {
      // eslint-disable-next-line react/prop-types
      const { setSearchFilter, searchFilter } = this.props;
      this.setState({ filterTypeData: value }, () => {
        setSearchFilter({
          ...searchFilter, filterTypeData: value
        });
        this._onSearchTypeList();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSearchTypeList = () => {
    try {
      const { filterTypeData, typeSearchResult } = this.state;
      const searchRes = [];
      const searchData = new RegExp(filterTypeData.toUpperCase(), 'g');
      const data = typeSearchResult.filter((item) => item.OptionName.match(searchData));
      data.map((item) => {
        searchRes.push(item);
      });
      this.setState({
        types: filterTypeData !== '' ? searchRes : typeSearchResult
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onProcedureChange = (value) => {
    try {
      // eslint-disable-next-line react/prop-types
      const { setSearchFilter, searchFilter } = this.props;
      this.setState({ filterProcedureData: value }, () => {
        setSearchFilter({
          ...searchFilter, filterProcedureData: value
        });
        this._onSearchProcedureList();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSearchProcedureList = () => {
    try {
      const { filterProcedureData, procedureSearchResult } = this.state;
      const searchRes = [];
      const searchData = new RegExp(filterProcedureData.toUpperCase(), 'g');
      const data = procedureSearchResult.filter((item) => item.OptionName.match(searchData));
      data.map((item) => {
        searchRes.push(item);
      });
      this.setState({
        procedures: filterProcedureData !== '' ? searchRes : procedureSearchResult
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onPatientIDChange = (value) => {
    try {
      // eslint-disable-next-line react/prop-types
      const { setSearchFilter, searchFilter } = this.props;
      this.setState({ filterPatientIDData: value }, () => {
        setSearchFilter({
          ...searchFilter, filterPatientIDData: value
        });
        this._onSearchPatientIDList();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSearchPatientIDList = () => {
    try {
      const { filterPatientIDData, patientSearchResult } = this.state;
      const searchRes = [];
      const searchData = new RegExp(filterPatientIDData.toUpperCase(), 'g');
      const data = patientSearchResult.filter((item) => item.PatientID.match(searchData));
      data.map((item) => {
        searchRes.push(item);
      });
      this.setState({
        patients: filterPatientIDData !== '' ? searchRes : patientSearchResult
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSearch = (value) => {
    try {
      const {
        isSearchRep,
        isSearchHospital,
        isSearchSurgeon,
        isSearchType,
        isSearchProcedure,
        isSearchPatientID,
        filterRepData,
        filterHospitalData,
        filterSurgeonData,
        filterTypeData,
        filterProcedureData,
        filterPatientIDData
      } = this.state;
      // eslint-disable-next-line react/prop-types
      const { setSearchFilter } = this.props;
      this.setState({
        isSearchRep: value === 'isSearchRep' ? !isSearchRep : false,
        isSearchHospital: value === 'isSearchHospital' ? !isSearchHospital : false,
        isSearchSurgeon: value === 'isSearchSurgeon' ? !isSearchSurgeon : false,
        isSearchType: value === 'isSearchType' ? !isSearchType : false,
        isSearchProcedure: value === 'isSearchProcedure' ? !isSearchProcedure : false,
        isSearchPatientID: value === 'isSearchPatientID' ? !isSearchPatientID : false,
        filterRepData: value === 'isSearchRep' ? '' : filterRepData,
        filterHospitalData: value === 'isSearchHospital' ? '' : filterHospitalData,
        filterSurgeonData: value === 'isSearchSurgeon' ? '' : filterSurgeonData,
        filterTypeData: value === 'isSearchType' ? '' : filterTypeData,
        filterProcedureData: value === 'isSearchProcedure' ? '' : filterProcedureData,
        filterPatientIDData: value === 'isSearchPatientID' ? '' : filterPatientIDData,
      }, () => {
        value === 'isSearchRep' && this._onRepChange('');
        value === 'isSearchHospital' && this._onHospitalChange('');
        value === 'isSearchSurgeon' && this._onSurgeonChange('');
        value === 'isSearchType' && this._onTypeChange('');
        value === 'isSearchProcedure' && this._onProcedureChange('');
        value === 'isSearchPatientID' && this._onPatientIDChange('');
      });
      setSearchFilter({
        isSearchRep: value === 'isSearchRep' ? !isSearchRep : false,
        isSearchHospital: value === 'isSearchHospital' ? !isSearchHospital : false,
        isSearchSurgeon: value === 'isSearchSurgeon' ? !isSearchSurgeon : false,
        isSearchType: value === 'isSearchType' ? !isSearchType : false,
        isSearchProcedure: value === 'isSearchProcedure' ? !isSearchProcedure : false,
        isSearchPatientID: value === 'isSearchPatientID' ? !isSearchPatientID : false,
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFilterData = () => {
    try {
      const { searchFilter } = this.props;
      this.setState({
        filterRepData: searchFilter.filterRepData !== undefined ? searchFilter.filterRepData : '',
        filterHospitalData: searchFilter.filterHospitalData !== undefined ? searchFilter.filterHospitalData : '',
        filterSurgeonData: searchFilter.filterSurgeonData !== undefined ? searchFilter.filterSurgeonData : '',
        filterTypeData: searchFilter.filterTypeData !== undefined ? searchFilter.filterTypeData : '',
        filterProcedureData: searchFilter.filterProcedureData !== undefined ? searchFilter.filterProcedureData : '',
        filterPatientIDData: searchFilter.filterPatientIDData !== undefined ? searchFilter.filterPatientIDData : '',
      }, () => {
        searchFilter.filterRepData !== undefined ? this._onSearchRepList() : '';
        searchFilter.filterHospitalData !== undefined ? this._onSearchHospitalList() : '';
        searchFilter.filterSurgeonData !== undefined ? this._onSearchSurgeonList() : '';
        searchFilter.filterTypeData !== undefined ? this._onSearchTypeList() : '';
        searchFilter.filterProcedureData !== undefined ? this._onSearchProcedureList() : '';
        searchFilter.filterPatientIDData !== undefined ? this._onSearchPatientIDList() : '';
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const { selectedFilter, tableName, searchFilter } = this.props;
      if (tableName !== 'Cases') {
        await this._setBillingFilterData();
      } else {
        const proceduresRes = await getProcedureTypes();
        const typeRes = await getAltCaseTypes();
        const sortType = sortData(typeRes, 'AltCaseType');
        const surgeonsRes = await getSurgeons();
        const sortSurgeons = sortData(surgeonsRes, 'SurgeonName');
        const hospitalRes = await getHospitals();
        const sortHospital = sortData(hospitalRes, 'CustomerName');
        const repRes = await getTeamReps();
        const sortRep = sortData(repRes, 'SalesRepName');
        this.setState({
          procedures: proceduresRes,
          procedureSearchResult: proceduresRes,
          types: sortType,
          typeSearchResult: sortType,
          surgeons: sortSurgeons,
          surgeonSearchResult: sortSurgeons,
          hospitals: sortHospital,
          hospitalSearchResult: sortHospital,
          repData: sortRep,
          repSearchResult: sortRep,
          isSearchRep: searchFilter.isSearchRep !== undefined ? searchFilter.isSearchRep : '',
          isSearchHospital: searchFilter.isSearchHospital !== undefined ? searchFilter.isSearchHospital : '',
          isSearchSurgeon: searchFilter.isSearchSurgeon !== undefined ? searchFilter.isSearchSurgeon : '',
          isSearchType: searchFilter.isSearchType !== undefined ? searchFilter.isSearchType : '',
          isSearchProcedure: searchFilter.isSearchProcedure !== undefined ? searchFilter.isSearchProcedure : '',
          isSearchPatientID: searchFilter.isSearchPatientID !== undefined ? searchFilter.isSearchPatientID : '',
          selectedStartDate: (selectedFilter.hasOwnProperty('selectedStartDate'))
            ? new Date(selectedFilter.selectedStartDate)
            : '',
          selectedEndDate: (selectedFilter.hasOwnProperty('selectedEndDate'))
            ? new Date(selectedFilter.selectedEndDate)
            : '',
          selectedTypes: (selectedFilter.hasOwnProperty('selectedTypes'))
            ? selectedFilter.selectedTypes
            : [],
          selectHospitals: (selectedFilter.hasOwnProperty('selectHospitals'))
            ? selectedFilter.selectHospitals
            : [],
          selectedRefs: (selectedFilter.hasOwnProperty('selectedRefs'))
            ? selectedFilter.selectedRefs
            : [],
          selectedProcedures: (selectedFilter.hasOwnProperty('selectedProcedures'))
            ? selectedFilter.selectedProcedures
            : [],
          selectSurgeon: (selectedFilter.hasOwnProperty('selectSurgeon'))
            ? selectedFilter.selectSurgeon
            : [],
          keywordSearch: (selectedFilter.hasOwnProperty('keywordSearch'))
            ? (selectedFilter.keywordSearch).join(',')
            : '',
          PatientID: (selectedFilter.hasOwnProperty('PatientID'))
            ? selectedFilter.PatientID
            : [],
          sortOrder: (selectedFilter.hasOwnProperty('sortOrder'))
            ? selectedFilter.sortOrder
            : 'desc'
        }, () => {
          this._onFilterData();
        });
      }
      this.setClearFilter();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      selectHospitals, selectSurgeon, selectedProcedures, selectedTypes, repData,
      selectedEndDate, selectedStartDate, selectedRefs, PatientID,
      hospitals, surgeons, types, procedures, patients, keywordSearch, sortOrder,
      clearData, filterRepData, isSearchRep, filterHospitalData, isSearchHospital,
      filterSurgeonData, isSearchSurgeon, filterTypeData, isSearchType,
      filterProcedureData, isSearchProcedure, filterPatientIDData, isSearchPatientID
    } = this.state;
    const { title, filter, searchFilter } = this.props;
    const {
      keywords = false, date = false, sort = false, patient = false
    } = filter;
    return (
      <section className="filter-section">
        <div className="container">
          <div className="top-block">
            <div className="row">
              <div className="col">
                <h4>{title}</h4>
              </div>
              <div className="col-auto text-end">
                <Link
                  className={`${Object.keys(clearData).length > 0 ? 'cursor-pointer' : 'btn-clear-filter'}`}
                  onClick={Object.keys(clearData).length > 0 ? this._onClearFilter : () => { }}
                >Clear Search
                </Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="accordion accordion-flush accordion-filter" id="accordionFilter">
                {date && (
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button" type="button"
                      >
                        Time Period
                      </button>
                      <Link
                        className="btn btn-theme-alt btn-today"
                        onClick={this._clearDateFilter}
                      >
                        Today
                      </Link>
                      <Link onClick={this._onFutureData} className="btn btn-theme-alt btn-future">Future</Link>
                      {(selectedStartDate !== '' || selectedEndDate !== '')
                        && (
                          <Link
                            className="btn btn-link" onClick={this._onDateClear}
                          >Clear
                          </Link>
                        )}
                    </div>
                    <div
                      id="collapseOne" className="accordion-collapse collapse show"
                    >
                      <div className="accordion-body time-period">
                        <div className="row gx-3">
                          <div className="col-6">
                            <DatePicker
                              dateFormat="MM/dd/yyyy"
                              className="form-control"
                              placeholderText="Start Date"
                              selected={selectedStartDate}
                              onChangeRaw={(e) => {
                                e.preventDefault();
                              }}
                              onChange={(value) => {
                                this._onFilter({ selectedStartDate: value });
                                this.setState({ selectedStartDate: value }, () => {
                                  this.setClearFilter();
                                });
                              }}
                            />
                          </div>
                          <div className="col-6">
                            <DatePicker
                              dateFormat="MM/dd/yyyy"
                              className="form-control"
                              placeholderText="End Date"
                              selected={selectedEndDate}
                              onChangeRaw={(e) => {
                                e.preventDefault();
                              }}
                              onChange={(value) => {
                                this._onFilter({ selectedEndDate: value });
                                this.setState({ selectedEndDate: value }, () => {
                                  this.setClearFilter();
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* {
                  poIssue && (
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingTwo">
                      { selectPOIssues.length > 0
                      && (
                        <Link
                          className="btn btn-link"
                          onClick={() => this._onClear('selectPOIssues')}
                        >Clear
                        </Link>
                      )}
                      <button
                        className="accordion-button collapsed" type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo" aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        PO Issue
                      </button>
                    </div>
                    <div
                      id="collapseTwo" className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionFilter"
                    >
                      <div className="accordion-body pt-0 rep">
                        <Select2
                          style={{ width: '100%' }}
                          multiple
                          className="form-control"
                          data={poIssues.map((value) => value.text)}
                          value={selectPOIssues}
                          onSelect={this._onSelectPOIssue}
                          onUnselect={({ target: { value } }) =>
                          this._onUnSelectPOIssue(value)}
                          options={
                          {
                            placeholder: 'Search',
                          }
                        }
                        />
                      </div>
                    </div>
                    {
                      poIssues.map((po, index) => (
                        <div key={index}>
                          {selectPOIssues.includes(po.text) && (
                            <div className="selection">
                              <p>{po.text}</p>
                              <button className="btn"
                              onClick={() => this._onUnSelectPOIssue(po.text)}>
                                <i className="fas fa-times" />
                              </button>
                            </div>
                          )}
                        </div>
                      ))
                    }
                  </div>
                  )
                } */}
                <div className="accordion-item">
                  <div className="accordion-header" id="heading2">
                    {(selectedRefs.length > 0 && !isSearchRep)
                      && (
                        <Link
                          className="btn btn-link" onClick={() => this._onClear('selectedRefs')}
                        >Clear
                        </Link>
                      )}
                    <button
                      className={`${!searchFilter.isSearchRep ? 'accordion-button collapsed' : 'accordion-button'}`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse2" aria-expanded="false"
                      aria-controls="collapse2"
                      onClick={() => this._onSearch('isSearchRep')}
                    >
                      Rep
                    </button>
                  </div>
                  <div
                    id="collapse2"
                    className={`${!searchFilter.isSearchRep ? 'accordion-collapse collapse' : 'accordion-collapse collapse show'}`}
                    aria-labelledby="heading2"
                    data-bs-parent="#accordionFilter"
                  >
                    <div className="accordion-body pt-0 rep">
                      <div className="accordion-body p-0">
                        <input
                          type="text"
                          className="form-control search-input-focus"
                          value={filterRepData}
                          onChange={({ target: { value } }) => {
                            this._onRepChange(value);
                          }}
                          placeholder="Search"
                        />
                      </div>
                      {!isEmpty(repData) && repData.map((item, key) => (
                        <div className="topping day-filter-item" key={key}>
                          <label className="cursor-pointer mt-2">
                            <input
                              type="checkbox"
                              onClick={() => this._onSelectRef(item.SalesRepName)}
                              checked={selectedRefs.indexOf(item.SalesRepName) > -1}
                              readOnly
                              id={item.SalesRepName}
                            />
                            <span className="me-2" />
                            <a>{item.SalesRepName}</a>
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                  {
                    !isSearchRep && repData.map((rep, index) => (
                      <div key={index}>
                        {selectedRefs.includes(rep.SalesRepName) && (
                          <div className="selection">
                            <p>{rep.SalesRepName}</p>
                            <button className="btn" onClick={() => this._onUnSelectRef(rep.SalesRepName)}>
                              <i className="fas fa-times" />
                            </button>
                          </div>
                        )}
                      </div>
                    ))
                  }
                </div>
                <div className="accordion-item">
                  <div className="accordion-header" id="headingThree">
                    {(selectHospitals.length > 0 && !isSearchHospital)
                      && (
                        <Link
                          className="btn btn-link" onClick={() => this._onClear('selectHospitals')}
                        >Clear
                        </Link>
                      )}
                    <button
                      className={`${!searchFilter.isSearchHospital ? 'accordion-button collapsed' : 'accordion-button'}`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree" aria-expanded="false"
                      aria-controls="collapseThree"
                      onClick={() => this._onSearch('isSearchHospital')}
                    >
                      Hospital
                    </button>
                  </div>
                  <div
                    id="collapseThree"
                    className={`${!searchFilter.isSearchHospital ? 'accordion-collapse collapse' : 'accordion-collapse collapse show'}`}
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionFilter"
                  >
                    <div className="accordion-body pt-0">
                      <div className="accordion-body p-0">
                        <input
                          type="text"
                          className="form-control search-input-focus"
                          value={filterHospitalData}
                          onChange={({ target: { value } }) => {
                            this._onHospitalChange(value);
                          }}
                          placeholder="Search"
                        />
                      </div>
                      {!isEmpty(hospitals) && hospitals.map((item, key) => (
                        <div className="topping day-filter-item" key={key}>
                          <label className="cursor-pointer mt-2">
                            <input
                              type="checkbox"
                              onClick={() => this._onSelectHospital(item.CustomerName)}
                              checked={selectHospitals.indexOf(item.CustomerName) > -1}
                              readOnly
                              id={item.CustomerName}
                            />
                            <span className="me-2" />
                            <a>{item.CustomerName}</a>
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                  {
                    !isSearchHospital && hospitals.map((hospital, index) => (
                      <div key={index}>
                        {selectHospitals.includes(hospital.CustomerName) && (
                          <div className="selection">
                            <p>{hospital.CustomerName}</p>
                            <button className="btn" onClick={() => this._onUnSelectHospital(hospital.CustomerName)}>
                              <i className="fas fa-times" />
                            </button>
                          </div>
                        )}
                      </div>
                    ))
                  }
                </div>
                <div className="accordion-item">
                  <div className="accordion-header" id="headingFour">
                    {(selectSurgeon.length > 0 && !isSearchSurgeon)
                      && (
                        <Link
                          className="btn btn-link" onClick={() => this._onClear('selectSurgeon')}
                        >Clear
                        </Link>
                      )}
                    <button
                      className={`${!searchFilter.isSearchSurgeon ? 'accordion-button collapsed' : 'accordion-button'}`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour" aria-expanded="false"
                      aria-controls="collapseFour"
                      onClick={() => this._onSearch('isSearchSurgeon')}
                    >
                      Surgeon
                    </button>
                  </div>
                  <div
                    className={`${!searchFilter.isSearchSurgeon ? 'accordion-collapse collapse' : 'accordion-collapse collapse show'}`}
                    id="collapseFour"
                    aria-labelledby="headingFour"
                    data-bs-parent="#accordionFilter"
                  >
                    <div className="accordion-body pt-0">
                      <div className="accordion-body p-0">
                        <input
                          type="text"
                          className="form-control search-input-focus"
                          value={filterSurgeonData}
                          onChange={({ target: { value } }) => {
                            this._onSurgeonChange(value);
                          }}
                          placeholder="Search"
                        />
                      </div>
                      {!isEmpty(surgeons) && surgeons.map((item, key) => (
                        <div className="topping day-filter-item" key={key}>
                          <label className="cursor-pointer mt-2">
                            <input
                              type="checkbox"
                              onClick={() => this._onSelectSurgeon(item.SurgeonName)}
                              checked={selectSurgeon.indexOf(item.SurgeonName) > -1}
                              readOnly
                              id={item.SurgeonName}
                            />
                            <span className="me-2" />
                            <a>{item.SurgeonName}</a>
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                  {
                    !isSearchSurgeon && surgeons.map((surgeon, index) => (
                      <div key={index}>
                        {selectSurgeon.includes(surgeon.SurgeonName) && (
                          <div className="selection">
                            <p>{surgeon.SurgeonName}</p>
                            <button className="btn" onClick={() => this._onUnSelectSurgeon(surgeon.SurgeonName)}>
                              <i className="fas fa-times" />
                            </button>
                          </div>
                        )}
                      </div>
                    ))
                  }
                </div>
                <div className="accordion-item">
                  <div className="accordion-header" id="headingFive">
                    {(selectedTypes.length > 0 && !isSearchType)
                      && (
                        <Link
                          className="btn btn-link" onClick={() => this._onClear('selectedTypes')}
                        >Clear
                        </Link>
                      )}
                    <button
                      className={`${!searchFilter.isSearchType ? 'accordion-button collapsed' : 'accordion-button'}`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFive" aria-expanded="false"
                      aria-controls="collapseFive"
                      onClick={() => this._onSearch('isSearchType')}
                    >
                      Type
                    </button>
                  </div>
                  <div
                    id="collapseFive"
                    className={`${!searchFilter.isSearchType ? 'accordion-collapse collapse' : 'accordion-collapse collapse show'}`}
                    aria-labelledby="headingFive"
                    data-bs-parent="#accordionFilter"
                  >
                    <div className="accordion-body pt-0">
                      <div className="accordion-body p-0">
                        <input
                          type="text"
                          className="form-control search-input-focus"
                          value={filterTypeData}
                          onChange={({ target: { value } }) => {
                            this._onTypeChange(value);
                          }}
                          placeholder="Search"
                        />
                      </div>
                      {!isEmpty(types) && types.map((item, key) => (
                        <div className="topping day-filter-item" key={key}>
                          <label className="cursor-pointer mt-2">
                            <input
                              type="checkbox"
                              onClick={() => this._onSelectType(item.AltCaseType)}
                              checked={selectedTypes.indexOf(item.AltCaseType) > -1}
                              readOnly
                              id={item.AltCaseType}
                            />
                            <span className="me-2" />
                            <a>{item.AltCaseType}</a>
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                  {
                    !isSearchType && types.map((type, index) => (
                      <div key={index}>
                        {selectedTypes.includes(type.OptionName) && (
                          <div className="selection">
                            <p>{type.OptionName}</p>
                            <button className="btn" onClick={() => this._onUnSelectType(type.OptionName)}>
                              <i className="fas fa-times" />
                            </button>
                          </div>
                        )}
                      </div>
                    ))
                  }
                </div>
                <div className="accordion-item">
                  <div className="accordion-header" id="headingSix">
                    {(selectedProcedures.length > 0 && !isSearchProcedure)
                      && (
                        <Link
                          className="btn btn-link" onClick={() => this._onClear('selectedProcedures')}
                        >Clear
                        </Link>
                      )}
                    <button
                      className={`${!searchFilter.isSearchProcedure ? 'accordion-button collapsed' : 'accordion-button'}`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseSix" aria-expanded="false"
                      aria-controls="collapseSix"
                      onClick={() => this._onSearch('isSearchProcedure')}
                    >
                      Procedure
                    </button>
                  </div>
                  <div
                    id="collapseSix"
                    className={`${!searchFilter.isSearchProcedure ? 'accordion-collapse collapse' : 'accordion-collapse collapse show'}`}
                    aria-labelledby="headingSix"
                    data-bs-parent="#accordionFilter"
                  >
                    <div className="accordion-body pt-0">
                      <div className="accordion-body p-0">
                        <input
                          type="text"
                          className="form-control search-input-focus"
                          value={filterProcedureData}
                          onChange={({ target: { value } }) => {
                            this._onProcedureChange(value);
                          }}
                          placeholder="Search"
                        />
                      </div>
                      {!isEmpty(procedures) && procedures.map((item, key) => (
                        <div className="topping day-filter-item" key={key}>
                          <label className="cursor-pointer mt-2">
                            <input
                              type="checkbox"
                              onClick={() => this._onSelectProcedures(item.OptionName)}
                              checked={selectedProcedures.indexOf(item.OptionName) > -1}
                              readOnly
                              id={item.OptionName}
                            />
                            <span className="me-2" />
                            <a>{item.OptionName}</a>
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                  {
                    !isSearchProcedure && procedures.map((procedure, index) => (
                      <div key={index}>
                        {selectedProcedures.includes(procedure.OptionName) && (
                          <div className="selection">
                            <p>{procedure.OptionName}</p>
                            <button className="btn" onClick={() => this._onUnSelectProcedure(procedure.OptionName)}>
                              <i className="fas fa-times" />
                            </button>
                          </div>
                        )}
                      </div>
                    ))
                  }
                </div>
                {keywords && (
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingSeven">
                      {keywordSearch !== ''
                        && (
                          <Link
                            className="btn btn-link" onClick={() => this._onClear('keywordSearch')}
                          >Clear
                          </Link>
                        )}
                      <button
                        className="accordion-button" type="button"
                      >
                        Keyword
                      </button>
                    </div>
                    <div
                      id="collapseSeven" className="accordion-collapse collapse show"
                    >
                      <div className="accordion-body pt-0">
                        <input
                          type="text"
                          className="form-control search-input-focus"
                          onChange={((event) => {
                            this._onKeyword(event);
                          })}
                          placeholder="Search patient name, notes, etc."
                          value={keywordSearch}
                        />
                        <p className="note">To search by more than one word, separate each word with a comma.</p>
                      </div>
                    </div>
                  </div>
                )}
                {patient && (
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingTen">
                      {(PatientID.length > 0 && !isSearchPatientID)
                        && (
                          <Link
                            className="btn btn-link" onClick={() => this._onClear('PatientID')}
                          >Clear
                          </Link>
                        )}
                      <button
                        className={`${!searchFilter.isSearchPatientID ? 'accordion-button collapsed' : 'accordion-button'}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTen" aria-expanded="false"
                        aria-controls="collapseTen"
                        onClick={() => this._onSearch('isSearchPatientID')}
                      >
                        Patient
                      </button>
                    </div>
                    <div
                      id="collapseTen"
                      className={`${!searchFilter.isSearchPatientID ? 'accordion-collapse collapse' : 'accordion-collapse collapse show'}`}
                      aria-labelledby="headingTen"
                      data-bs-parent="#accordionFilter"
                    >
                      <div className="accordion-body pt-0">
                        <div className="accordion-body p-0">
                          <input
                            type="text"
                            className="form-control search-input-focus"
                            value={filterPatientIDData}
                            onChange={({ target: { value } }) => {
                              this._onPatientIDChange(value);
                            }}
                            placeholder="Search"
                          />
                        </div>
                        {!isEmpty(patients) && patients.map((item, key) => (
                          <div className="topping day-filter-item" key={key}>
                            <label className="cursor-pointer mt-2">
                              <input
                                type="checkbox"
                                onClick={() => this._onSelectPatient(item.PatientID)}
                                checked={PatientID.indexOf(item.PatientID) > -1}
                                readOnly
                                id={item.PatientID}
                              />
                              <span className="me-2" />
                              <a>{item.PatientID}</a>
                            </label>
                          </div>
                        ))}
                      </div>

                    </div>
                    {
                      !isSearchPatientID && patients.map((patientData, index) => (
                        <div key={index}>
                          {PatientID.includes(patientData.PatientID) && (
                            <div className="selection">
                              <p>{patientData.PatientID}</p>
                              <button className="btn" onClick={() => this._onUnSelectPatient(patientData.PatientID)}>
                                <i className="fas fa-times" />
                              </button>
                            </div>
                          )}
                        </div>
                      ))
                    }
                  </div>
                )}
              </div>
            </div>
          </div>
          {sort && (
            <div className="top-block">
              <div className="row">
                <div className="col-12 mb-3">
                  <h4>Sort</h4>
                </div>
                <div className="col-12">
                  <div className="btn-group w-100" role="group">
                    <button
                      type="button"
                      className={`btn btn-theme-alt btn-theme-outline-alt ${sortOrder === 'desc' && 'active'}`}
                      value="desc"
                      onClick={(e) => this._onSort(e)}
                    >Newest - Oldest
                    </button>
                    <button
                      type="button"
                      className={`btn btn-theme-alt btn-theme-outline-alt ${sortOrder === 'asc' && 'active'}`}
                      value="asc"
                      onClick={(e) => this._onSort(e)}
                    >Oldest - Newest
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    );
  }
}

Filter.propTypes = {
  title: PropTypes.string.isRequired,
  filter: PropTypes.objectOf(PropTypes.bool).isRequired,
  onFilter: PropTypes.func.isRequired,
  previousData: PropTypes.objectOf(PropTypes.any).isRequired,
  selectedFilter: PropTypes.objectOf(PropTypes.any).isRequired,
  onClearFilter: PropTypes.func.isRequired,
  tableName: PropTypes.string.isRequired,
  searchFilter: PropTypes.objectOf(PropTypes.any).isRequired
};

export default withSearchFilter(
  withTableName(
    withCaseFilter(
      Filter
    )
  )
);
